<div class="roleDetailTitle" mat-dialog-title>Detalle de Rol</div>
<div mat-dialog-content class="roleDetailContent">
  <div fxLayout="row wrap" fxLayoutGap="50px" fxLayout.lt-sm="column">
    <div fxFlex="25" *ngFor="let route of routesResp.routes" class="flexItem">
      <mat-checkbox [(ngModel)]="route.checked" color="primary">{{route.routeName}}</mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions fxLayoutAlign="end start" fxLayoutAlign.lt-sm="center start" class="flexButton">
  <button (click)="saveChanges()" mat-raised-button color="primary">
    <mat-icon>save</mat-icon> Guardar</button>
  <a (click)="close()" mat-raised-button>
    <mat-icon>cancel</mat-icon> Cancelar</a>
</div>
